let preventScroll = (e) => e.preventDefault();

export function enableScrollLock() {
  document.body.addEventListener('touchmove', preventScroll, {
    passive: false,
  });
  document.addEventListener('touchmove', preventScroll, { passive: false });
}

export function disableScrollLock() {
  document.body.removeEventListener('touchmove', preventScroll, {
    passive: false,
  });
  document.removeEventListener('touchmove', preventScroll, { passive: false });
}

let scrollPosition = 0;

export function lockBodyScroll() {
  scrollPosition = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollPosition}px`;
  document.body.style.width = '100%';
}

export function unlockBodyScroll() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';

  // Temporarily disable smooth scroll
  const html = document.documentElement;
  const prevScrollBehavior = html.style.scrollBehavior;
  html.style.scrollBehavior = 'auto';

  // Scroll back go the original place
  window.scrollTo(0, scrollPosition);

  // Restore previous scroll behavior
  html.style.scrollBehavior = prevScrollBehavior;
}
